import {formatPhone} from '@/helpers/phone'

export const filters = {
  phone: formatPhone,
}
